import type { RouteObject } from 'react-router-dom';

import { PrintAccessProvider } from '../access';
import withLazyLoading from '../hoc/withLazyLoading';
import withPostHogTracker from '../composeRouter';

const EmailPage = withLazyLoading(() => import('../pages/EmailPage'));
const DashboardA4PrintPage = withLazyLoading(() => import('../pages/dashboardA4PrintPage'));

export const printRoutes: RouteObject[] = [
  {
    path: '/emailPage/:plantId/:pageId/:days/:startDateUrl/:endDateUrl/:granularity',
    element: withPostHogTracker(
      <PrintAccessProvider>
        <EmailPage />
      </PrintAccessProvider>,
    ),
  },
  {
    path: '/dashboardA4PrintPage/:plantId/:pageId/:days/:startDateUrl/:endDateUrl/:granularity',
    element: withPostHogTracker(
      <PrintAccessProvider>
        <DashboardA4PrintPage />
      </PrintAccessProvider>,
    ),
  },
];
